import './UserTag.scss'
import React from 'react'
import { TagElement } from '../../../components/Tag/Tag'

export type UserTagType = 'managed' | 'external' | 'anonymous' | 'current' | string

const USER_TYPE_LABEL_MAP: { [key in UserTagType]: string } = {
  managed: 'Teammate',
  external: 'Contact',
  anonymous: 'Guest',
  current: 'You',
}

export interface UserTagProps extends React.ComponentProps<'div'> {
  withoutStyle?: boolean
  userType?: UserTagType
}

export const UserTag: React.FC<UserTagProps> = ({ userType = 'anonymous', className, withoutStyle = false, ...rest }) => {
  const tagStyle = withoutStyle ? '' : `${userType}-user-tag-style`
  const tagLabel = USER_TYPE_LABEL_MAP[userType]

  return (
    <TagElement className={`${tagStyle} ${className ? className : ''}`} {...rest}>
      {tagLabel}
    </TagElement>
  )
}
